import { gql } from "@apollo/client";

export const GET_OFFICE_ACTIVITY = gql`
  query GetOfficeActivity($filter: OfficeActivityFilter, $limit: Int, $offset: Int) {
    getOfficeActivity(filter: $filter, limit: $limit, offset: $offset) {
      status
      message
      data {
        officeHours {
          start
          end
        }
        people {
          actorId
          actorName
          actorType
          actions
          errors
          sensitive
          afterHours
          cancellations
          bookingEdits
          reassignments
          walletCredited
          walletDebited
          manualPayments
          moneyActions
          activeDays
          firstAt
          lastAt
        }
        categories {
          category
          actions
        }
        days {
          day
          actions
          sensitive
        }
        total
        entries {
          id
          createdAt
          actorType
          actorId
          actorName
          action
          category
          targetType
          targetId
          bookingId
          amount
          outcome
          message
          args
          ip
          sensitive
          afterHours
        }
      }
    }
  }
`;
